import { render, staticRenderFns } from "./ShowCurricula.vue?vue&type=template&id=60b8750b&"
import script from "./ShowCurricula.vue?vue&type=script&lang=js&"
export * from "./ShowCurricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports